import { useEffect } from "react"

export default function About() {

    useEffect(() => {
        document.title = `rw - bio & cv`;
    }, [])

    return (
        <div id="about">
            <div id="bio">
                <p>ruby makes to process and situate things and how we process and situate them. 
                    she is dedicated to her intuition. 
                    ruby believes in silence, dance, and a long-term faith.
                </p>
            </div>
            <div id="cv">
                <h2>education</h2>
                <p>bfa, ruskin school of art, oxford university [2024-2027]</p>
                <p>foundation diploma in art & design, central saint martins [2024]</p>
                <h2>shows</h2>
                <p>chinese whispers, oxford [2026]</p>
                <p>like a prayer, london [2026]</p>
                <p>halfway up a spiral staircase, oxford [2025]</p>
            </div>
        </div>
    )
}